export const FIND_TABLE_ENTRIES_REQUEST = 'FIND_TABLE_ENTRIES_REQUEST';

export const findTableEntriesRequest = () => ({
    type: FIND_TABLE_ENTRIES_REQUEST,
    payload: {}
});
